import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Table } from 'antd'
import React, { Fragment } from 'react'
import { SystemRegisterProps } from '../interface'

export const SystemRegister: React.FC<SystemRegisterProps> = (
  props: SystemRegisterProps
) => {
  const { data, size, pagination, onSearch } = props
  const [form] = Form.useForm()
  const formatMessage = getFormatMessage()
  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.system.register.name' }),
      key: 'app.system.register.name',
      dataIndex: 'name'
    },
    {
      title: formatMessage({ id: 'app.system.register.address' }),
      key: 'app.system.register.address',
      dataIndex: 'address'
    },
    {
      title: formatMessage({ id: 'app.system.register.dataWidth' }),
      key: 'app.system.register.dataWidth',
      dataIndex: 'dataWidth'
    },
    {
      title: formatMessage({ id: 'app.system.register.description' }),
      key: 'app.system.register.description',
      dataIndex: 'description'
    }
  ]

  const handleSearch = () => {
    const values = form.getFieldsValue()
    onSearch?.(values)
  }

  return (
    <Fragment>
      <Form form={form} layout='inline' style={{ marginBottom: 16 }}>
        <Form.Item name='name'>
          <Input
            allowClear
            placeholder={formatMessage({
              id: 'app.system.register.name.placeholder'
            })}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            icon={<SearchOutlined />}
            onClick={handleSearch}
          >
            {formatMessage({
              id: 'app.system.register.search'
            })}
          </Button>
        </Form.Item>
      </Form>
      <Table
        rowKey='id'
        columns={defaultColumns}
        dataSource={data}
        pagination={pagination}
        size={size}
      />
    </Fragment>
  )
}
